import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Nav from "./components/Nav/Nav";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import Contact from "./pages/Contact/Contact";
import ContactUs from "./components/Contact/Contact";
import About from "./pages/About/About";
import Faqs from "./pages/FAQ/FAQ";
import Packages from "./pages/packages/Packages";
import Itinerary from "./pages/Iterinary/Iterinary";
import Privacy from "./pages/Privacy/Privacy";
import Terms from "./pages/Terms/Terms";
import "./App.css";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }, [pathname]);

  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <div>
        <ScrollToTop />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Faqs" element={<Faqs />} />
          <Route path="/itinerary" element={<Itinerary />} />
          <Route path="/itinerary/:slug" element={<Itinerary />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          {/* You can add more routes like: */}
          {/* <Route path="/packages" element={<Packages />} /> */}
          {/* <Route path="/contact" element={<Contact />} /> */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
        <ContactUs />
        <Footer />
      </div>
    </Router>
  );
};

export default App;
